import api from 'axios'

/**
 * Signal types
 */
export const LOAD_ALL = 'abl-backoffice/residentialArea/LOAD_ALL'
export const RESET_ALL = 'abl-backoffice/residentialArea/RESET_ALL'

/**
 * @returns {function(*)}
 */
export const fetchAll = () => {
	const request = api.get('/webapi/residential-areas')

	return dispatch => {
		return request.then(response => {
			dispatch(loadAll(response.data))
			return response.data;
		})
	}
}

/**
 * @param data
 */
export const loadAll = data => ({type: LOAD_ALL, data})
